import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PageLoadService {

  private _loadStartTime: number;

  constructor() { }

  setloadStartTime() {
    this._loadStartTime = Date.now();
  }

  get loadStartTime() {
    return this._loadStartTime;
  }
}
